<template>
    <div class="container-xl">
        <main class="py-4">
            <form>
                <div class="row g-3 mb-4 align-items-center justify-content-between">
                    <div class="col-auto">
                        <h1 class="app-page-title mb-0">{{ __('schedules.manage-schedules-title') }}</h1>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="card mb-3">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="instructor" class="col-form-label">{{ __('form.instructor-name')
                                                }}</label>
                                            <multiselect
                                                :key="schedule.instructor ? schedule.instructor.id : 'instructor-empty'"
                                                id="instructor" v-model="schedule.instructor" :options="instructors"
                                                label="name" track-by="id" :placeholder="translationChooseInstructor">
                                            </multiselect>
                                            <span v-if="errors.instructor" class="invalid-feedback d-block">{{
                                                errors.instructor[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="questionnaire" class="col-form-label">{{
                                                __('form.questionnaire') }}:</label>
                                            <multiselect
                                                :key="schedule.questionnaire ? schedule.questionnaire.id : 'questionnaire-empty'"
                                                id="questionnaire" v-model="schedule.questionnaire"
                                                :options="active_questionnaires" label="name" track-by="id"
                                                :placeholder="translationChooseQuestionnaire">
                                            </multiselect>
                                            <span v-if="errors.questionnaire" class="invalid-feedback d-block">{{
                                                errors.questionnaire[0] }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="company_name" class="col-form-label">{{ __('form.company-name')
                                                }}:</label>
                                            <input type="text" class="form-control" id="company_name"
                                                v-model="schedule.company_name">
                                            <span v-if="errors.company_name" class="invalid-feedback d-block">{{
                                                errors.company_name[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="notes" class="col-form-label">{{ __('form.project-code')
                                                }}:</label>
                                            <input type="text" class="form-control" id="project_code"
                                                v-model="schedule.project_code">
                                            <span v-if="errors.project_code" class="invalid-feedback d-block">{{
                                                errors.project_code[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="location" class="col-form-label">{{ __('form.location')
                                                }}:</label>
                                            <input type="text" class="form-control" id="location"
                                                v-model="schedule.location">
                                            <span v-if="errors.location" class="invalid-feedback d-block">{{
                                                errors.location[0] }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="name" class="col-form-label">{{ __('form.participant-name')
                                                }}:</label>
                                            <input type="text" class="form-control" id="name"
                                                v-model="schedule.participant_name">
                                            <span v-if="errors.participant_name" class="invalid-feedback d-block">{{
                                                errors.participant_name[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="name" class="col-form-label">{{ __('form.participant-email')
                                                }}:</label>
                                            <input type="text" class="form-control" id="email"
                                                v-model="schedule.participant_email">
                                            <span v-if="errors.participant_email" class="invalid-feedback d-block">{{
                                                errors.participant_email[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="name" class="col-form-label">{{ __('form.participant-phone')
                                                }}:</label>
                                            <input type="text" class="form-control" id="phone"
                                                v-model="schedule.participant_phone">
                                            <span v-if="errors.participant_phone" class="invalid-feedback d-block">{{
                                                errors.participant_phone[0] }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="name" class="col-form-label">{{ __('form.participant-license-plate')
                                                }}:</label>
                                            <input type="text" class="form-control" id="license_plate"
                                                v-model="schedule.participant_license_plate">
                                            <span v-if="errors.participant_license_plate" class="invalid-feedback d-block">{{
                                                errors.participant_license_plate[0] }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <label for="date" class="form-label">Datum</label>
                                        <input :class="{ 'is-invalid': errors.length }" type="date" :min="getMinDate()"
                                            class="form-control" id="start_date" v-model="schedule.start_date">
                                        <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0]
                                            }}</span>
                                    </div>
                                    <div class="col-md-4">
                                        <label for="start_time" class="form-label">Tijd</label>
                                        <input :class="{ 'is-invalid': errors.length }" :step="600" type="time"
                                            class="form-control" id="start_time" v-model="schedule.start_time">
                                        <span v-if="errors.length" class="invalid-feedback d-block">{{ errors[0]
                                            }}</span>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="notes" class="col-form-label">{{ __('form.notes') }}:</label>
                                            <textarea class="form-control" id="notes" v-model="schedule.notes"
                                                rows="5"></textarea>
                                            <span v-if="errors.notes" class="invalid-feedback d-block">{{
                                                errors.notes[0] }}</span>
                                        </div>
                                    </div>

                                </div>

                                <div class="form-check mb-3" v-if="!isEdit">
                                    <input class="form-check-input" type="checkbox" v-model="addAnother"
                                        name="addAnother" id="addAnother">
                                    <label class="form-check-label" for="addAnother">{{ __('schedules.add-another')
                                        }}</label><br />
                                    <input class="form-check-input" type="checkbox" v-model="prefillValues"
                                        name="prefillValues" id="prefillValues">
                                    <label class="form-check-label" for="prefillValues">Neem waardes mee</label>
                                </div>
                                <div class="col-md-12">
                                    <button type="button" class="btn app-btn-primary"
                                        @click="isEdit ? updateSchedule() : createSchedule()">{{ __('actions.submit')
                                        }}</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </main>
    </div>
</template>

<script>
export default {
    name: "AddUpdateScheduleComponent",

    props: {
        instructors: {
            type: Array,
            required: true
        },

        questionnaires: {
            type: Array,
            required: true
        },

        scheduleData: {
            type: Object,
            required: true
        }
    },

    computed: {
        isEdit: function () {
            return !!this.schedule.id;
        },
        active_questionnaires() {
            return this.questionnaires.filter(value => value.is_active == true)
        }
    },

    data: function () {
        return {
            schedule: this.getScheduleDataModel(),
            translationChooseInstructor: this.__('schedules.choose-instructor'),
            translationChooseQuestionnaire: this.__('schedules.choose-questionnaire'),
            errors: [],
            addAnother: true,
            prefillValues: true
        }
    },

    mounted: function () {
        if (this.scheduleData.id) {
            this.schedule = this.scheduleData
            this.errors = {}
        }
    },

    methods: {
        getScheduleDataModel: function () {
            return {
                company_name: null,
                participant_name: null,
                participant_email: null,
                participant_phone: null,
                participant_license_plate: null,
                instructor: null,
                location: null,
                questionnaire: null,
                start_date: null,
                start_time: null,
                notes: null,
                project_code: null,
            }
        },

        resetForm: function (all) {

            this.schedule.start_time = null
            this.schedule.notes = null
            this.schedule.participant_name = null
            this.schedule.participant_email = null
            this.schedule.participant_phone = null
            this.schedule.participant_license_plate = null

            if (all) {
                this.schedule.company_name = null
                this.schedule.project_code = null
                this.schedule.instructor = null
                this.schedule.location = null
                this.schedule.questionnaire = null
                this.schedule.start_date = null
            }
        },

        getMinDate: function () {
            var today = new Date();
            return today.getFullYear()
                + '-'
                + ('0' + (today.getMonth() + 1)).slice(-2)
                + '-'
                + today.getDate();
        },

        createSchedule: function () {
            this.errors = []
            axios.post(`/schedules`, this.schedule).then(response => {
                Toast.fire({ icon: 'success', title: response.data.message })

                if (this.addAnother) {
                    this.resetForm(!this.prefillValues)
                } else {
                    window.location.href = '/schedules';
                }
            }).catch(error => {
                Toast.fire({ icon: 'error', title: error.response.data.message })
                this.errors = error.response.data.errors
            })
        },

        updateSchedule: function () {
            axios.put(`/schedules/${this.schedule.id}`, this.schedule).then(response => {
                Toast.fire({ icon: 'success', title: response.data.message })
                window.location.href = '/schedules';
            }).catch(error => {
                console.log(error)
                Toast.fire({ icon: 'error', title: error.response.data.message })
                this.errors = error.response.data.errors
            })
        }
    }
}
</script>

<style scoped></style>
